import React, { Component } from 'react'
import PropTypes from 'prop-types'
import uuid from 'uuid'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
  ConfigurationDocuments,
  ConfigurationAssessor,
  ConfigurationEmails,
  ConfigurationOther
} from 'containers/sections/configurations'
import { Section, SubTabs, SubTab } from 'components/layout'
import { ConfigurationKeySetModal } from 'components/modals'
import { apiConfiguration, apiCodeLists, apiContacts } from 'helpers/decorators/api'
import { meta, form } from 'helpers/decorators'
import { codeListsByIdSelector } from 'redux/selectors/codeLists'
import { get } from 'lodash'

const enhance = compose(
  meta({
    title: 'My Region Office - Customizations',
    intlKey: 'route.my_region_office_customization'
  }),
  apiConfiguration(),
  form({
    form: 'form-change-config-value'
  }),
  apiContacts({
      active: true
    }),
  apiCodeLists(),
  connect(state => ({
    codeListsById: codeListsByIdSelector(state)
  }))
)

class MyRegionOfficeCustomization extends Component {
  static propTypes = {
    route: PropTypes.object.isRequired,
    isConfigUpdating: PropTypes.bool,
    modal: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    fetchCodeListById: PropTypes.func.isRequired,
    codeListsById: PropTypes.array,
    change: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    onUpdateConfigKey: PropTypes.func.isRequired,
    onResetConfigKey: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    isSameLevel: PropTypes.bool,
    contacts: PropTypes.object
  }

  state = {
    config: {}
  }

  key = uuid.v1()

  handleChangeConfig = config => {
    this.setState(
      {
        config
      },
      () => {
        this.props.modal(`modal-configuration-key-${this.key}`)
      }
    )
  }

  render() {
    const { handleSubmit, isSameLevel, route, contacts } = this.props

    const editCustomizationEnabled = get(contacts, 'active.editCustomizationEnabled')


    return (
      <Section>
        <SubTabs compact>
          <SubTab title="Documents" intlKey="moduleTitle.documents">
            <ConfigurationDocuments
              isSameLevel={isSameLevel}
              route={route}
              changeConfig={this.handleChangeConfig}
              editCustomizationEnabled={editCustomizationEnabled}
            />
          </SubTab>
          <SubTab title="Emails" intlKey="moduleTitle.emails">
            <ConfigurationEmails
              isSameLevel={isSameLevel}
              route={route}
              changeConfig={this.handleChangeConfig}
              editCustomizationEnabled={editCustomizationEnabled}
            />
          </SubTab>
          <SubTab title="Assessor" intlKey="moduleTitle.assessor">
            <ConfigurationAssessor
              isSameLevel={isSameLevel}
              route={route}
              changeConfig={this.handleChangeConfig}
              editCustomizationEnabled={editCustomizationEnabled}
            />
          </SubTab>
          <SubTab title="Other" intlKey="label.other">
            <ConfigurationOther
              isSameLevel={isSameLevel}
              route={route}
              changeConfig={this.handleChangeConfig}
              editCustomizationEnabled={editCustomizationEnabled}
            />
          </SubTab>
        </SubTabs>

        <ConfigurationKeySetModal
          modalId={`modal-configuration-key-${this.key}`}
          data={this.state.config}
          handleSubmit={handleSubmit}
          onUpdateConfigKey={this.props.onUpdateConfigKey}
          onResetConfigKey={this.props.onResetConfigKey}
          modal={this.props.modal}
          reset={this.props.reset}
          change={this.props.change}
          initialize={this.props.initialize}
          isConfigUpdating={this.props.isConfigUpdating}
          fetchCodeListById={this.props.fetchCodeListById}
          codeListsById={this.props.codeListsById}
        />
      </Section>
    )
  }
}

export default enhance(MyRegionOfficeCustomization)
